import type { StandsKeys } from '@packages/config/Stands';
import { appHosts } from '@packages/config/appHosts';
import type { Pages } from 'config/helmet/pages';
import type React from 'react';
import type { HelmetProps } from 'react-helmet';
const stand = String(process.env.stand) as StandsKeys;

const defaultMeta: React.JSX.IntrinsicElements['meta'][] = [
	{
		property: 'og:image:alt',
		content: 'Маркетплейс банковских продуктов',
	},
	{
		property: 'og:description',
		content: 'Ефин - маркетплейс банковских продуктов и не только',
	},
	{
		itemProp: 'description',
		content: 'Ефин - маркетплейс банковских продуктов и не только',
	},
	{
		name: 'description',
		content: 'Ефин - маркетплейс банковских продуктов и не только',
	},
	{
		name: 'apple-mobile-web-app-title',
		content: 'Ефин',
	},
];

const defaultHelmetConfig: HelmetProps = {
	title: 'Подберём и доставим быстрее, чем гонщики Формулы-1',
};

export const helmetConfig: { [key in Pages]: HelmetProps } = {
	main: {
		...defaultHelmetConfig,
		meta: [
			...defaultMeta,
			{
				name: 'robots',
				content: 'index, follow',
			},
			{
				name: 'robots',
				content: 'noarchive',
			},
			{
				name: 'keywords',
				content:
					'Eфин, Efin, список банков, банки москвы, банки, кредитные карты, дебетовые карты, карты, в реестре ОФП ЦБ РФ, кредит онлайн, оформить кредитную карту',
			},
		],
		link: [
			{
				rel: 'canonical',
				href: `${appHosts.efr[stand]}/`,
			},
		],
	},
	app: {
		...defaultHelmetConfig,
		meta: [
			...defaultMeta,
			{
				name: 'robots',
				content: 'index, follow',
			},
			{
				name: 'robots',
				content: 'noarchive',
			},
			{
				name: 'keywords',
				content:
					'Eфин, Efin, список банков, банки москвы, банки, кредитные карты, дебетовые карты, карты, в реестре ОФП ЦБ РФ, кредит онлайн, оформить кредитную карту',
			},
		],
		link: [
			{
				rel: 'canonical',
				href: `${appHosts.efr[stand]}/`,
			},
		],
	},
};
